import React, { ReactNode, useState, useEffect } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { Sidebar } from './Sidebar';
import {useAuth} from "../contexts/AuthContext";
import {SetupRequirement} from "../api/api-client";

interface LayoutProps {
  children: ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarWidth, setSidebarWidth] = useState(300);
  const [isDesktop, setIsDesktop] = useState(false);
  const { isInitialized, isAuthenticated, setupNeeded, masterKey } = useAuth();

  // Check if we're on desktop (lg breakpoint)
  useEffect(() => {
    const checkIsDesktop = () => {
      setIsDesktop(window.innerWidth >= 992); // Bootstrap lg breakpoint
    };

    checkIsDesktop();
    window.addEventListener('resize', checkIsDesktop);
    return () => window.removeEventListener('resize', checkIsDesktop);
  }, []);

  // Auto-open sidebar on desktop
  useEffect(() => {
    if (isDesktop) {
      setSidebarOpen(true);
    }
  }, [isDesktop]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="d-flex flex-column vh-100">
      <NavMenu onToggleSidebar={toggleSidebar} />
      <div className="flex-grow-1 d-flex" style={{ height: 0 }}>
        {isInitialized && isAuthenticated && (setupNeeded === SetupRequirement.None && masterKey) && <>
           {/* Sidebar - takes space on desktop, overlay on mobile */}
          {isDesktop && sidebarOpen && (
            <div style={{ width: `${sidebarWidth}px`, flexShrink: 0, height: '100%' }}>
              <Sidebar
                isOpen={sidebarOpen}
                onToggle={toggleSidebar}
                width={sidebarWidth}
                onWidthChange={setSidebarWidth}
                isOverlay={false}
              />
            </div>
          )}
          
          {/* Mobile overlay sidebar */}
          {!isDesktop && (
            <Sidebar
              isOpen={sidebarOpen}
              onToggle={toggleSidebar}
              width={sidebarWidth}
              onWidthChange={setSidebarWidth}
              isOverlay={true}
            />
          )}
        </>}
        
        {/* Main content */}
        <Container 
          fluid 
          tag="main" 
          className="flex-grow-1 d-flex flex-column"
          style={{ minWidth: 0, overflowX: 'hidden' }}
        >
          {children}
        </Container>
      </div>
    </div>
  );
};